import http from '../utils/http';
import { AREA_URL } from '../constants/endpoints';

export async function fetchAll() {
  return await http.get(AREA_URL);
}
